/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PreLoginMutationVariables = Exact<{
  email: string;
}>;


export type PreLoginMutation = { preLogin: { is_success: boolean } | null };


export const PreLoginDocument = /*#__PURE__*/ gql`
    mutation PreLogin($email: String!) {
  preLogin(email: $email) {
    is_success
  }
}
    `;
export type PreLoginMutationFn = Apollo.MutationFunction<PreLoginMutation, PreLoginMutationVariables>;

/**
 * __usePreLoginMutation__
 *
 * To run a mutation, you first call `usePreLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preLoginMutation, { data, loading, error }] = usePreLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePreLoginMutation(baseOptions?: Apollo.MutationHookOptions<PreLoginMutation, PreLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreLoginMutation, PreLoginMutationVariables>(PreLoginDocument, options);
      }
export type PreLoginMutationHookResult = ReturnType<typeof usePreLoginMutation>;
export type PreLoginMutationResult = Apollo.MutationResult<PreLoginMutation>;
export type PreLoginMutationOptions = Apollo.BaseMutationOptions<PreLoginMutation, PreLoginMutationVariables>;